export default __webpack_public_path__ + "static/gatsby_github_auto_deploy-68a625eb842fd543e485ec5f51c37972.png";